const config = {
  terrainStyleId: 'cj3ve0eew02fi2smkj52shgo2',
  hybridStyleId: 'cj459rh840a4d2ro7xdlcr411',
};

module.exports = config;
